import _DatePicker from "antd/es/date-picker";
var _excluded = ["dropdownClassName"],
  _excluded2 = ["dropdownClassName"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import cn from 'classnames';
import './index.less';
var OneDatePicker = function OneDatePicker(props) {
  var dropdownClassName = props.dropdownClassName,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(_DatePicker, _extends({
    dropdownClassName: cn('one-picker-dropdown', dropdownClassName),
    className: cn('one-date-picker', props.className)
  }, rest));
};
var OneRangePicker = function OneRangePicker(props) {
  var dropdownClassName = props.dropdownClassName,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(_DatePicker.RangePicker, _extends({
    dropdownClassName: cn('one-picker-dropdown-range', dropdownClassName)
  }, rest));
};
OneDatePicker.RangePicker = OneRangePicker;
OneDatePicker.displayName = 'OneDatePicker';
OneRangePicker.displayName = 'OneRangePicker';
export default OneDatePicker;